import angular from 'angular';
import announcementComponent from './announcement.component';

let announcementModule = angular.module('announcement', [])

    .component('announcement', announcementComponent)

    .name;

let states = [
    {
        name: 'announcement',
        url: '/announcement/{id}',
        component: 'announcement'
    },
    {
        name: 'news',
        url: '/blog/{id}',
        component: 'announcement'
    }
];

export default {name: announcementModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/announcement/announcement.js